module.exports = __webpack_public_path__ + "img/feature-1.e52e1704.svg";